import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 15m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0","key":"svg-0"}],["path",{"d":"M10 7h4","key":"svg-1"}],["path",{"d":"M10 18v4l2 -1l2 1v-4","key":"svg-2"}],["path",{"d":"M10 19h-2a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-2","key":"svg-3"}]]

const IconCertificate2 = createReactComponent('outline', 'certificate-2', 'Certificate2', __iconNode);

export default IconCertificate2;